import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const MASTERS_BASE = `${config.BASE_URL}/membership-control`;


async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

function assertOk(res, data, fallbackMessage) {
  if (!res.ok) throw new Error(data.message || fallbackMessage);
}

export const fetchMembershipTypes = async () => {
  const res = await authFetch(`${MASTERS_BASE}/types`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch membership types");
  return data;
};

export const createMembershipType = async (data, csrfToken) => {
  const res = await authFetch(`${MASTERS_BASE}/types`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(
      csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    ),
    body: JSON.stringify(data),
  });
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to create membership type");
  return payload;
};

export const updateMembershipType = async (id, data, csrfToken) => {
  const res = await authFetch(
    `${MASTERS_BASE}/types/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      credentials: "include",
      headers: buildAuthHeaders(
        csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      ),
      body: JSON.stringify(data),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to update membership type");
  return payload;
};

/** Soft delete: sets is_active = 2 on the server. */
export const deleteMembershipType = async (id, csrfToken) => {
  const res = await authFetch(
    `${MASTERS_BASE}/types/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: buildAuthHeaders(
        csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      ),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to remove membership type");
  return payload;
};

export const fetchDurationTypes = async () => {
  const res = await authFetch(`${MASTERS_BASE}/durations`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch duration types");
  return data;
};

export const createDurationType = async (data, csrfToken) => {
  const res = await authFetch(`${MASTERS_BASE}/durations`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(
      csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    ),
    body: JSON.stringify(data),
  });
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to create duration type");
  return payload;
};

export const updateDurationType = async (id, data, csrfToken) => {
  const res = await authFetch(
    `${MASTERS_BASE}/durations/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      credentials: "include",
      headers: buildAuthHeaders(
        csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      ),
      body: JSON.stringify(data),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to update duration type");
  return payload;
};

export const deleteDurationType = async (id, csrfToken) => {
  const res = await authFetch(
    `${MASTERS_BASE}/durations/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: buildAuthHeaders(
        csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      ),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to remove duration type");
  return payload;
};

export const fetchFeeTypes = async () => {
  const res = await authFetch(`${MASTERS_BASE}/fees`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to fetch fee types");
  return data;
};

export const createFeeType = async (data, csrfToken) => {
  const res = await authFetch(`${MASTERS_BASE}/fees`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(
      csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    ),
    body: JSON.stringify(data),
  });
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to create fee type");
  return payload;
};

export const updateFeeType = async (id, data, csrfToken) => {
  const res = await authFetch(
    `${MASTERS_BASE}/fees/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      credentials: "include",
      headers: buildAuthHeaders(
        csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      ),
      body: JSON.stringify(data),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to update fee type");
  return payload;
};

export const deleteFeeType = async (id, csrfToken) => {
  const res = await authFetch(
    `${MASTERS_BASE}/fees/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: buildAuthHeaders(
        csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      ),
    },
  );
  const payload = await parseJson(res);
  assertOk(res, payload, "Failed to remove fee type");
  return payload;
};
